module.exports = __webpack_public_path__ + "media/src/assets/404-81f653216ca8f7f2892a1f075eebd0e8.png";